// GAVION pw-reset-delegated: Settings → Integrations → "System email sender" (admins).
export const systemSenderEn = {
  title: "System email sender",
  description:
    'The noreply mailbox sends the "Forgot password?" emails. An administrator connects it once, signing in to Microsoft with the noreply account (not their own).',
  status: {
    none: "Not connected",
    disconnected: "Not connected",
    connected: "Connected",
    needs_reauth: "Reconnect needed",
  },
  connect: "Connect the noreply sender",
  reconnect: "Reconnect the noreply sender",
  disconnect: "Disconnect",
  sign_in_as:
    'In the Microsoft window, sign in with %{address} (choose "Use another account" if needed).',
  connected_as: "Connected: %{email}",
  last_refresh: "Last token refresh: %{at}",
  never_refreshed: "Token not refreshed yet",
  not_configured:
    'The sending address (PASSWORD_RESET_FROM) is not set: see the "Password reset" runbook.',
  mismatch:
    "The connected mailbox is not %{address}: reconnect the sender with that account. No email goes out meanwhile.",
  needs_reauth_help:
    'Microsoft refused the token: "Forgot password?" emails no longer go out. Reconnect the noreply sender.',
  connected_toast: "Noreply sender connected.",
  disconnected_toast: "Noreply sender disconnected.",
  confirm_disconnect_title: "Disconnect the noreply sender?",
  confirm_disconnect_body:
    '"Forgot password?" emails will not go out until it is connected again. Administrators can still hand out a "Password link".',
  errors: {
    system_sender_mismatch:
      "This Microsoft account is not the expected sending mailbox. Sign in again with the noreply account.",
    system_sender_not_configured:
      "The sending address (PASSWORD_RESET_FROM) is not set.",
    forbidden: "Administrators only.",
  },
};
